export { schemaFieldType } from './om2-form-field/common/util.js';

/* Metadata for each layout schema field:
 *
 * The key names are types returned from schemaFieldType()
 *
 * The values (layout.type) tell us how to render and treat each field
 *
 * All data under layout.type.fields is passed on to om2-form to render the
 * form (with the exception of anything under layout.type.fields.formModal which is used
 * by our om2-form-modal component to customize things a bit).
 */
const layout = {
  root: {
    restrictParent: [], // The root cannot have a parent
    maxContents: Number.MAX_SAFE_INTEGER,
  },
  array: {
    maxContents: Number.MAX_SAFE_INTEGER,
    summary: 'id',
    restrictContents: ['column'],
    fields: {
      id: {
        title: 'Id',
        tooltip: 'The unique id used when saving values for this array input',
        type: 'string',
        required: true,
      },
      minRows: {
        title: 'Minimum Rows',
        type: 'number',
        min: 0,
        multipleOf: 1,
      },
      'removeButton.class': {
        title: 'Remove Button CSS Class',
        tooltip:
          'This is a space separated list of css classes (typically from bulma/omni-ui)',
        default: 'is-medium no-border-background is-shadowless is-text',
        type: 'string',
      },
      'removeButton.icon.id': {
        title: 'Remove Button Icon Id',
        tooltip: 'The icon id in the remove button (from omni-ui)',
        default: 'omni:interactive:remove',
        type: 'string',
      },
      'removeButton.icon.class': {
        title: 'Remove Button Icon CSS Class',
        tooltip:
          'This is a space separated list of css classes (typically from bulma/omni-ui)',
        default: 'is-size-2',
        type: 'string',
      },
      'removeButton.text': {
        title: 'Remove Button Text',
        tooltip:
          'Text to be added to the remove button instead of or in addition to an icon',
        type: 'string',
      },
      'addButton.class': {
        title: 'Add Button CSS Class',
        tooltip:
          'This is a space separated list of css classes (typically from bulma/omni-ui)',
        default: 'is-outlined',
        type: 'string',
      },
      'addButton.icon.id': {
        title: 'Add Button Icon Id',
        tooltip: 'The icon id in the add button (from omni-ui)',
        default: 'omni:interactive:add',
        type: 'string',
      },
      'addButton.icon.class': {
        title: 'Add Button Icon CSS Class',
        tooltip:
          'This is a space separated list of css classes (typically from bulma/omni-ui)',
        default: 'is-size-2',
        type: 'string',
      },
      'addButton.text': {
        title: 'Add Button Text',
        tooltip:
          'Text to be added to the add button instead of or in addition to an icon',
        type: 'string',
      },
      class: {
        title: 'CSS Class',
        tooltip:
          'This is a space separated list of css classes (typically from bulma/omni-ui)',
        type: 'string',
      },
    },
  },
  box: {
    maxContents: Number.MAX_SAFE_INTEGER,
    fields: {
      class: {
        title: 'CSS Class',
        tooltip:
          'This is a space separated list of css classes (typically from bulma/omni-ui)',
        type: 'string',
      },
    },
  },
  row: {
    maxContents: Number.MAX_SAFE_INTEGER,
    restrictContents: ['column'],
    fields: {
      class: {
        title: 'CSS Class',
        tooltip:
          'This is a space separated list of css classes (typically from bulma/omni-ui)',
        type: 'string',
      },
    },
  },
  column: {
    maxContents: Number.MAX_SAFE_INTEGER,
    restrictParent: ['row', 'array'],
    fields: {
      class: {
        title: 'CSS Class',
        tooltip:
          'This is a space separated list of css classes (typically from bulma/omni-ui)',
        type: 'string',
      },
    },
  },
  ref: {
    maxContents: 0,
    summary: 'id',
    label: 'input field',
    fields: {
      id: {
        title: 'Input Field',
        tooltip: 'Select which input field to place here',
        type: 'string',
        required: true,
        enum: [], // This should be populated dynamically
        formModal: { fullWidth: true },
      },
    },
  },
};

// Additional layout fields and all input fields will be added dynamically when the form
// field registers itself.
export const metadata = { layout, fields: {} };
